<template>
  <div class="we-branches">

    <div class="we-branch"
    v-for="(branch, index) in branchList"
    :key="index"
    :id="`ex-${index}`"
    >

      <!-- banner -->
      <div class="we-branch-banner" :style="{'background': branch.bannerImg}">
        <div class="we-branch-content">
          <h1 class="we-branch-title">
            <span class="pingfang-family">TGO</span> 鲲鹏会{{ branch.name }}董事会成员</h1>
          <h2 class="we-branch-subtitle" v-if="branch.spellName">Council of {{ branch.spellName }}</h2>
        </div>
      </div>

      <!-- member-info -->
      <div class="we-branch-members container">
        <div class="we-branch-member"
        v-for="(member, idx) in branch.content"
        :key="idx">
          <div class="img">
            <img :src="(member.half_length_portrait.trim() || defaultHalfPortrait) | compressImg" alt="">
          </div>
          <div class="official_position">{{ member.position_type | formatPosition }}</div>
          <div class="name">
            <span v-if="member.name">{{ member.name }}</span>
            <!-- <span v-if="member.spell_name">{{ member.spell_name }}</span> -->
          </div>
          <div class="company" v-if="member.company_name">{{ member.company_name }}</div>
          <div class="position" v-if="member.official_position">{{ member.job_title | formatJobTitles }}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { defaultHalfPortrait } from '@/data/default'
import { innerPosition, jobTitles } from '@/data/form'
import branchesInfo from './branch.info'

import VueBus from '@/util/vueBus'

export default {
  data () {
    return {
      defaultHalfPortrait, // 默认半身头像
      branchesInfo, // 分会背景及分会名字拼音
      eachBranchScroll: [] // 每个分会进入屏幕中线对应页面 scroll 值
    }
  },
  props: {
    /**
     * 所有分会
     */
    branchList: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean
    }
  },
  methods: {
    /**
     * 获取所有分会元素相对屏幕中线的位置 [when scrollTop === 0]
     */
    getBranchClientRect () {
      let pageScrollTop = document.documentElement.scrollTop
      let clientHeight = document.documentElement.clientHeight

      let branches = document.querySelectorAll('.we-branch')
      branches.forEach(ele => {
        // 因为页面会记住上一次的滚动位置，所以要去除掉 scrollTop 的偏移量
        this.eachBranchScroll.push(ele.getBoundingClientRect().top - clientHeight / 2 + pageScrollTop)
      })
    },
    /**
     * 监听页面 scrollTop 值, 获取进入屏幕中线的 branch 的 index
     */
    listenActiveIndex () {
      let pageScrollTop = document.documentElement.scrollTop

      let index = 0
      while (pageScrollTop > this.eachBranchScroll[index]) {
        ++index
      }
      index -= 1

      VueBus.$emit('setTargetIndex', index)
    }
  },
  filters: {
    formatPosition (type) {
      let innerPositionMap = {}
      innerPosition.forEach(element => { innerPositionMap[element.id] = element })
      return (innerPositionMap[type] && innerPositionMap[type].name) || ''
    },
    formatJobTitles (type) {
      let map = {}
      jobTitles.forEach(element => { map[element.id] = element })
      return map[type].name
    },
    compressImg (link) {
      return `${link}?x-oss-process=image/resize,m_fill,h_${Math.floor(232 * window.devicePixelRatio)},w_${Math.floor(190 * window.devicePixelRatio)}`
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listenActiveIndex)

    VueBus.$on('scrollToTargetBranch', index => {
      window.removeEventListener('scroll', this.listenActiveIndex)
      this.$scrollTo(`#ex-${index}`, 500, {
        offset: this.scrollOffset,
        onDone: () => {
          window.addEventListener('scroll', this.listenActiveIndex)
        }
      })
    })
  },
  computed: {
    scrollOffset () {
      return this.isMobile ? -40 : -76
    }
  },
  watch: {
    branchList: {
      handler: function (n) {
        if (n.length) {
          n.forEach(ele => {
            ele['bannerImg'] = `url(${(this.branchesInfo[ele.name] && this.branchesInfo[ele.name].img) || this.branchesInfo['北京'].img})`
            ele['spellName'] = (this.branchesInfo[ele.name] && this.branchesInfo[ele.name].spellName) || ''
          })

          this.$nextTick(() => { this.getBranchClientRect() })
        }
      }
      // immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.we-branch{
}

// common

.pingfang-family {
  font-family: PingFang SC;
}

// banner 部分
.we-branch-banner {
  background-attachment: fixed !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  position: relative;
  width: 100%;
  height: 200px;
  @include mobile {
      height: 150px;
  }
  .we-branch-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    @include mobile {
      width: 100%;
    }
    .we-branch-title {
      color: #fff;
      font-weight: 600;
      font-size: 39px;
      @include mobile {
        font-size: 6vw;
      }
    }
    .we-branch-subtitle {
      position: relative;
      color: $primary3;
      font-weight: 500;
      font-size: 29px;
      margin-top: 10px;
      padding-top: 16px;
      @include mobile {
        font-size: 5vw;
      }
      &::before {
        content: "";
        position: absolute;
        width: 30px;
        height: 3px;
        background: $primary3;
        left: 50%;
        transform: translateX(-50%);
        top: 0px;
        @include mobile {
          height: 2px;
        }
      }
    }
  }
}

// members-info
.we-branch-members {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 60px;
  padding-top: 20px;
  @include mobile {
    width: 100vw;
    padding: 8vw 7vw;
  }
}
.we-branch-member {
  width: 190px;
  margin-top: 40px;
  margin-right: 32px;
  @include mobile {
    width: 37vw;
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 30px;
    &:nth-of-type(2n+1) {
      margin-right: 12vw !important;
    }
  }
  &:nth-child(5n) {
    margin-right: 0;
  }
  .img {
    width: 100%;
    height: 232px;
    border-radius: 3px;
    overflow: hidden;
    @include mobile {
      height: auto;
    }
    img {
      width: 100%;
      height: 100%;
      @include mobile {
        height: auto;
      }
    }
  }
  .official_position {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: $primary3;
    margin-top: 15px;
  }
  .name {
    position: relative;
    margin: 0;
    margin-top: 2px;
    color: rgba(64,64,64,1);
    display: flex;
    align-items: center;
    overflow: hidden;
    span:first-child {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      flex-shrink: 0;
      @include limit-line-numbers(1)
    }
    // span:last-child {
    //   // position: absolute;
    //   // top: 4px;
    //   font-size: 16px;
    //   font-family: DIN Condensed;
    //   font-weight: bold;
    //   margin-left: 10px;
    //   transform: translateY(3px);
    //   @include limit-line-numbers(1)
    // }
  }
  .company, .position {
    color: #888888;
    font-size:14px;
    font-family: PingFang SC;
    font-weight: 500;
  }
}
</style>
